import React from 'react';
import { Box, Typography } from '@mui/material';
import { THEME_COLOR } from '../../../theme/formStyles';
import { fmtRange } from '../projectSchedule.utils';
import { taskRange, taskState } from './TimelineItemsList';

// "What the client sees": only the steps ticked Client, in timeline order
export default function ClientPreview({ items }) {
    const visible = items.filter(i => i.client_visible);
    return (
        <Box sx={{ border: '1px solid #e5e9ee', borderRadius: 3, p: 1.75, bgcolor: '#fff' }}>
            <Typography sx={{ fontWeight: 700, fontSize: '13.5px' }}>👁 What the client sees</Typography>
            <Typography sx={{ fontSize: '11.5px', color: '#6b7785', mb: 1.25 }}>Only steps ticked “Client”</Typography>
            {visible.map((it, i) => {
                const st = it.kind === 'task' ? taskState(it.sub_tasks) : it.status;
                const when = it.kind === 'task' ? taskRange(it.sub_tasks) : it.start_date ? fmtRange(it.start_date, it.end_date || it.start_date) : (it.date_label || 'Date TBD');
                return (
                    <Box key={it.key} sx={{ display: 'flex', gap: 1.25, position: 'relative', pb: 1.5 }}>
                        {i < visible.length - 1 && <Box sx={{ position: 'absolute', left: 9, top: 20, bottom: 0, width: 2, bgcolor: st === 'done' ? THEME_COLOR : '#e5e9ee' }} />}
                        <Box sx={{ width: 20, height: 20, borderRadius: '50%', flex: 'none', zIndex: 1, display: 'grid', placeItems: 'center', fontSize: 10, color: '#fff',
                            bgcolor: st === 'done' ? THEME_COLOR : '#fff', border: `2px solid ${st === 'done' || st === 'now' ? THEME_COLOR : '#e5e9ee'}`, boxShadow: st === 'now' ? '0 0 0 3px #e6f4f2' : 'none' }}>
                            {st === 'done' ? '✓' : ''}
                        </Box>
                        <Box sx={{ minWidth: 0 }}>
                            <Typography sx={{ fontSize: '12.5px', fontWeight: 500, color: st === 'now' ? THEME_COLOR : '#1f2933' }}>{it.kind === 'task' ? (it.task_name || 'Untitled task') : (it.label || 'Untitled step')}</Typography>
                            <Typography sx={{ fontSize: '11px', color: '#6b7785' }}>{when}</Typography>
                        </Box>
                    </Box>
                );
            })}
            {!visible.length && <Typography sx={{ fontSize: '12px', color: '#6b7785' }}>No steps shown to the client.</Typography>}
        </Box>
    );
}
